import { services } from '../Data.jsx';
import ServiceCard from './ServiceCard';
import { ReactComponent as Curve } from '../assets/curve_right.svg';

const Skills = () => {
    return (
        <section className="section-bg-b2 section pb-[50px]" id="skills">
            <div className="container grid grid-cols-1 lg:grid-cols-[5fr_5fr] gap-5 lg:gap-10 lg:gap-[100px] mt-[10px] px-2 lg:px-16 relative">
                {/* Left Column */}
                <div className="flex flex-col gap-5 lg:gap-10 lg:align-left">
                    <div className="text-center lg:text-left">
                        <h2 className="text-[clamp(1.75rem,_1.5rem_+_1.5vw,_2.5rem)] font-bold text-title mb-2 lg:mb-8 relative inline-block">Skills & Services</h2>
                        <p className="text-normal font-body leading-relaxed lg:w-[80%] mb-4 lg:mb-8 text-text text-center lg:text-left opacity-80">
                            What I’m good at — and the services I offer to build reliable, real-world digital products. My work spans frontend, backend, and system-level solutions focused on performance, usability, and maintainability.
                        </p>
                    </div>

                    {/* First Service Card */}
                    {services.slice(0, 1).map((item) => (
                        <ServiceCard key={item.id} item={item} />
                    ))}
                </div>

                {/* Decorative Curve Arrow - mirroring Projects section style but maybe positioned differently or kept same */}
                <div className="hidden min-[1400px]:block absolute left-[38%] top-[20%] z-0 opacity-60 text-primary pointer-events-none">
                    <Curve className="w-[20vw] h-[20vw] fill-current rotate-6" />
                </div>

                {/* Right Column */}
                <div className="flex flex-col gap-5 lg:gap-10">
                    {/* Remaining Service Cards */}
                    {services.slice(1, 3).map((item) => (
                        <ServiceCard key={item.id} item={item} className="lg:ml-auto" />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Skills